import { PropTypes } from "prop-types";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { API } from "aws-amplify";
import Main from "../components/Layout/Main/Main";
import Sidebar from "../components/Layout/Sidebar/Sidebar";
import AlumForm from "../components/AlumForm/AlumForm";
import { useAuth } from "../hooks/useAuth";
import { alumniProfilesByOwner } from "../graphql/queries";
import AlumProfile from "../components/AlumProfile/AlumProfile";

const propTypes = {
  cohorts: PropTypes.objectOf(PropTypes.any).isRequired,
};

const Alum = ({ cohorts }) => {
  const { ownerId } = useParams();
  const auth = useAuth();
  const isMyProfilePage = ownerId === auth.user.attributes.sub;
  const [hasLoaded, setHasLoaded] = useState(false);
  const [createProfile, setCreateProfile] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [alumniProfile, setAlumniProfile] = useState({});

  const resetStates = () => {
    setHasLoaded(false);
    setCreateProfile(false);
    setIsEditMode(false);
    setAlumniProfile({});
  };

  useEffect(() => {
    resetStates();
    const getProfile = async () => {
      try {
        let profile = await API.graphql({
          query: alumniProfilesByOwner,
          variables: { owner: ownerId },
        });
        profile = profile.data?.alumniProfilesByOwner?.items[0];
        if (profile) {
          setAlumniProfile(profile);
          setCreateProfile(false);
          setHasLoaded(true);
        } else if (isMyProfilePage) {
          setCreateProfile(true);
          setHasLoaded(true);
        }
        // TODO Else Redirect to 404 page
      } catch (e) {
        // TODO Redirect to 404 page
        console.log(e);
      }
    };
    getProfile();
  }, [ownerId, isMyProfilePage]);

  return (
    <>
      {hasLoaded && Object.keys(cohorts).length > 0 && (
        <Main>
          {isEditMode ? (
            <AlumForm
              cohorts={cohorts}
              alumniProfile={alumniProfile}
              setAlumniProfile={setAlumniProfile}
              setIsEditMode={setIsEditMode}
              setCreateProfile={setCreateProfile}
            />
          ) : (
            <AlumProfile
              cohort={cohorts[alumniProfile.cohortID]}
              alumniProfile={alumniProfile}
              createProfile={createProfile}
              isMyProfilePage={isMyProfilePage}
              setIsEditMode={setIsEditMode}
            />
          )}
        </Main>
      )}
      {hasLoaded && (
        <Sidebar>
          <div className="side-bar-content">Side bar content</div>
        </Sidebar>
      )}
    </>
  );
};

Alum.propTypes = propTypes;

export default Alum;
